module.exports = __WEBPACK_EXTERNAL_MODULE_13__;


//////////////////
// WEBPACK FOOTER
// external "polyglot"
// module id = 13
// module chunks = 0 1